export const LAZY_LOADED_CLASS = 'lazyloaded'
export const HAS_OBSERVER = 'IntersectionObserver' in window

export const LAZY_IMG_PLACEHOLDER = `data:image/svg+xml;charset=utf8,${encodeURI('<svg xmlns="http://www.w3.org/2000/svg" height="1px" width="1px"></svg>')}`
